/*
    GateLockRoom GATELOCK An Electronic Lock in a Gate
    Pic gatelock
    Hints 2006 2008
    InformOnEntry The gate is secured by this unusual electronic combination lock. Visiting Uncle Julius is always a bit of an adventure.
    RoomScriptBox D1  83 209 73 29 LOCK
    RoomScriptBox D2 174 209 73 29 LOCK
    RoomScriptBox D3 265 209 73 29 LOCK
    RoomScriptBox D4 356 209 73 29 LOCK
    GoBox HOMEGATE 0 261 512 59 HOMEGATE Out
*/

function GateLockRoom(game) {

    this.Room_constructor(game, 'gatelock');

    this.lock = new ComboLock(this, '2141', this.data('combo'));
}

createjs.extend(GateLockRoom, Room);

GateLockRoom.prototype.preload =
    function () {
        this.manifest =
            this.makeManifest(this.id, ['#scene']
                .concat(
                    this.lock.entityManifestSpec(),
                    {id: 'sound-opengate', full_src: 'sounds/gatelock-open_gate.wav'}
                )
            );

        this.Room_preload(this.manifest);
    };

GateLockRoom.prototype.load =
    function () {
        this.Room_load();

        this.lock.entityLoad();

        this.loadRetreatArea();

        /* Audio */
        this.sndOpenGate = this.world.queue.getResult('sound-opengate');

        return this;
    };

GateLockRoom.prototype.enter =
    function () {
        this.Room_enter(
            'The gate is secured by this unusual electronic combination lock. Visiting Uncle Julius is always a bit of an adventure.'
        );

        this.areaRetreatClickListener = this.areaRetreat.on('click', this.leave, this);

        return this;
    };

GateLockRoom.prototype.leave =
    function (nextKey) {
        this.data('combo', this.lock.combo);

        this.Room_leave(nextKey);
    };

GateLockRoom.prototype.solved =
    function () {
        createjs.Sound.play('gatelock-sound-opengate', {volume: 0.2});
        this.data('gateOpen', true, 'homegate');
        this.leave();
    }

GateLockRoom.prototype.next =
    function (nextKey) {
        return new HomeGateRoom(this.world);
    };

GateLockRoom.prototype.loadRetreatArea =
    function () {
        this.areaRetreat = this.makeHitRect(0, 261, 512, 59, 'back', 'out');
        this.reg(this.areaRetreat);
    };

createjs.promote(GateLockRoom, 'Room');
